import React from 'react';
import { Spinner } from 'reactstrap';

// style
import "assets/css/loading.css";

export default function Loading() {
    return (
        <div className="carregandoCmp">
            <div className="box">
                <Spinner></Spinner>
            </div>
        </div>
    )
}